function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Troubleshoot = function Troubleshoot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M4.49 3.78a.727.727 0 0 0-.73.73v4.02a.75.75 0 0 1-1.5 0V4.51c0-1.234.996-2.23 2.23-2.23h4.02a.75.75 0 0 1 0 1.5zm16.47 10.96a.75.75 0 0 1 .75.75v4.02c0 1.234-.996 2.23-2.23 2.23h-4.02a.75.75 0 1 1 0-1.5h4.02c.406 0 .73-.324.73-.73v-4.02a.75.75 0 0 1 .75-.75M17.9 3.14a.75.75 0 0 0-.958-.086l-3.81 2.65a.75.75 0 0 0-.312.737l.518 3.16-2.943 2.943L9.33 11.48a1.426 1.426 0 0 0-2.01 0l-3.33 3.33A3.671 3.671 0 0 0 9.18 20l3.33-3.33a1.426 1.426 0 0 0 0-2.01l-1.054-1.055 2.942-2.943 3.16.518a.75.75 0 0 0 .738-.312l2.65-3.81a.75.75 0 0 0-.086-.958zm-3.107 6.067-.416-2.541 2.906-2.022 2.073 2.073-2.022 2.906zm-6.468 3.389L5.05 15.87a2.171 2.171 0 0 0 3.07 3.07l3.274-3.275z",
    clipRule: "evenodd"
  }));
};
export default Troubleshoot;
Troubleshoot.displayName = 'Troubleshoot';